/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ErrorName from '../../../../core/error/error-name';

/**
 * @import { FileSystemFile as IFileSystemFile } from '../../../../core/file/system'
 * @import FileSystemPath from '../../../../core/file/system/file-system-path'
 * @import FileSystemManager from './file-system-manager';
 */

/**
 * Soubor v souborovém systému.
 * @implements {IFileSystemFile}
 */
export default class FileSystemFile {
  /**
   * @param {FileSystemPath} path
   * @param {FileSystemFileHandle} fileHandle
   * @param {FileSystemManager} fileSystemManager
   */
  constructor(path, fileHandle, fileSystemManager) {
    this.path = path;
    this.fileHandle = fileHandle;
    this.fileSystemManager = fileSystemManager;
    this.storage = fileSystemManager.storage;
  }

  /** @type {IFileSystemFile['getName']} */
  getName() {
    return this.path.getBase();
  }

  /** @type {IFileSystemFile['getPath']} */
  getPath() {
    return this.path;
  }

  /** @type {IFileSystemFile['isDirectory']} */
  isDirectory() {
    return false;
  }

  /** @type {IFileSystemFile['isFile']} */
  isFile() {
    return true;
  }

  /** @type {IFileSystemFile['move']} */
  async move(toPath) {
    if (await this.fileSystemManager.hasEntry(toPath)) {
      const error = new Error(`Entry ${toPath} already exists.`);
      error.name = ErrorName.PathExistsError;
      throw error;
    }
    const fileStream = await this.fileSystemManager.getFileStream(this.path);
    await this.fileSystemManager.writeStream(toPath, fileStream);
    await this.remove();
    return new FileSystemFile(
      toPath,
      await this.fileSystemManager.getFileHandle(toPath),
      this.fileSystemManager
    );
  }

  /** @type {IFileSystemFile['remove']} */
  async remove(opts) {
    if (!(await this.fileSystemManager.hasEntry(this.path))) {
      const error = new Error(`File ${this.path} not found.`);
      error.name = ErrorName.NotFoundError;
      throw error;
    }
    const parent = await this.fileSystemManager.getDirectParent(this.path);
    // Existuje aj fileHandle.remove, ale to sa vraj podľa MDN neodporúča.
    return await parent.removeEntry(this.path.getBase(), opts);
  }
}
